import React from "react";

const ComingSoon = () => {
  return (
    <div className="container">
      <div className="register_row align-items-center justify-content-center">
        <div className="main-content-regsiter coming_soon_sec">
          <div className="coming_soon_image">
            <img src="/images/comingsoon.png" alt="" />
          </div>
          <h2>COMING SOON!</h2>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
